import { STOModel } from "src/models/base/sto-model";
import { PendingApprovalsSummaryDTO } from "src/models/pending-approvals/pending-approvals-summary-dto";
import { BaseApiService } from "../base";

export class MyTeamPendingApprovalsSummaryApiService extends BaseApiService<PendingApprovalsSummaryDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/PendingApprovals",
      loadItemsPath: "/GetPendingApprovalsSummary",
    });
  }
}
